




/* Created- 10 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../../Models/Buttons";
@Component(
	{
		name: "ViewerConfigurationButtons",
		components: { ButtonList }
	})
export default class ViewerConfigurationButtons extends Vue {
	private buttons: ButtonConfig[] = [
		{ label: "Save", action: eParticaAction.WEBSITE_VIEWER_CONFIG_SAVE, type: ButtonType.OK } as ButtonConfig,
		{ label: "Swap", action: eParticaAction.WEBSITE_VIEWER_CONFIG_SWAP, type: ButtonType.Clear } as ButtonConfig,
		{ label: "Copy Live To Preview", action: eParticaAction.WEBSITE_VIEWER_CONFIG_COPY_LIVE, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Format JSON", action: eParticaAction.WEBSITE_VIEWER_CONFIG_FORMAT_JSON, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Publish", action: eParticaAction.WEBSITE_VIEWER_CONFIG_PUBLISH_JSON, type: ButtonType.Normal } as ButtonConfig,
	];
	private buttonClicked(clicked: ParticaEvent) {
		this.$emit("partica-event", clicked);
	}
}
